<div
    class="control-container"
    [formGroup]="form"
    [hidden]="isHidden"
    [title]="control.icon ? '' : control.tooltip"
>
    <ng-container *ngIf="dataSource$ | async; let dataSource">
        <se-autocomplete
            class="control"
            [required]="required"
            [disabled]="isDisabled"
            [dynamicAddEnabled]="false"
            [icon]="control.icon"
            [iconTooltip]="control.tooltip"
            [isOnError]="!formControl?.valid"
            [isWithLabel]="control.isWithLabel"
            [items]="dataSource"
            [placeholder]="control.isWithLabel ? placeholder : ''"
            [(value)]="model"
            (valueChange)="onValueChange($event)"
        >
        </se-autocomplete>
    </ng-container>
</div>
